import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#useDropdown">useDropdown()</a> ⇒ <inlineCode><a href="#Dropdown">Dropdown</a></inlineCode></dt>
      <dd>
        <p>{`A React Hook for adding dropdown-related logic.`}</p>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#Dropdown">Dropdown</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`The object returned contains the pieces needed to add the dropdown logic to your components`}</p>
      </dd>
    </dl>
    <p>{`A React Hook for adding dropdown-related logic.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<a parentName="p" {...{
        "href": "#Dropdown"
      }}><inlineCode parentName="a">{`Dropdown`}</inlineCode></a>{`
— An object containing functions and values to add dropdown logic`}</p>
    <p>{`The object returned contains the pieces needed to add the dropdown logic to your components`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`elementRef`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A `}<a parentName="td" {...{
              "href": "https://reactjs.org/docs/refs-and-the-dom.html"
            }}>{`ref`}</a>{` object for attaching to React elements`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`expanded`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The value of the `}<inlineCode parentName="td">{`expanded`}</inlineCode>{` state`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setExpanded`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://reactjs.org/docs/hooks-state.html"
            }}>{`State Hook`}</a>{` function for setting the expanded state`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`triggerRef`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A `}<a parentName="td" {...{
              "href": "https://reactjs.org/docs/refs-and-the-dom.html"
            }}>{`ref`}</a>{` object for attaching to React elements`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/hooks/useDropdown.js"
      }}>{`pwa-studio/packages/peregrine/lib/hooks/useDropdown.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      